var map = {
	"./Bodyswaps-logo-dataurl": "./src/assets/Bodyswaps-logo-dataurl.js",
	"./Bodyswaps-logo-dataurl.js": "./src/assets/Bodyswaps-logo-dataurl.js",
	"./Bodyswaps_NO.svg": "./src/assets/Bodyswaps_NO.svg",
	"./Bodyswaps_NO_mark.svg": "./src/assets/Bodyswaps_NO_mark.svg",
	"./Bodyswaps_WO.svg": "./src/assets/Bodyswaps_WO.svg",
	"./badge.png": "./src/assets/badge.png",
	"./body-bg.webp": "./src/assets/body-bg.webp",
	"./bodyswaps-logo-dark.png": "./src/assets/bodyswaps-logo-dark.png",
	"./clint-mckoy.jpg": "./src/assets/clint-mckoy.jpg",
	"./lock.jpg": "./src/assets/lock.jpg",
	"./login.jpg": "./src/assets/login.jpg",
	"./logo.png": "./src/assets/logo.png",
	"./main.css": "./src/assets/main.css",
	"./pricing.jpg": "./src/assets/pricing.jpg",
	"./register.jpg": "./src/assets/register.jpg",
	"./vuetify.svg": "./src/assets/vuetify.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";